import { ClientEnviroment } from "src/app/models/Security.User";


export const CLIENT_STYLES = new Map<string, ClientEnviroment | undefined>([
    // ['dragos.grecu@experian.com', ClientEnviroment.Sabadell],
    ['ivan.cedillo@experian.com', ClientEnviroment.Santander],
    ['jorge.ruiz@experian.com', ClientEnviroment.Unicaja]
]);
